import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { FileUploadData } from '../interfaces/File';

export async function uploadFile(folderName: string, file: File): Promise<StandardResponse<FileUploadData>> {
    const formData = new FormData();
    formData.append("file", file);

    const response: AxiosResponse<StandardResponse<FileUploadData>> = await api.post(`/files/upload?folder=${folderName}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}